import {IHostingZoneState} from "../reducers/hosting-zones.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {HostingDomainsZoneDataMapper} from "../../websites/website/hosting/domains/hosting-domains-zone-mapper";
import {TypeUtils} from "../../shared/utils/type-utils";
import {HostingDomainsRecordMapper} from "../../websites/website/hosting/domains/hosting-domains-record-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getZonesHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingZones);

export const getZones = (websiteId: any) => createSelector(getZonesHostingState,
  (state: IHostingZoneState) => {
    if (state.entities[websiteId] && !TypeUtils.isEmpty(state.entities[websiteId].entities)) {
      const data = Object.values(state.entities[websiteId].entities);
      const zoneData = {
        records: data[0],
        zone: HostingDomainsZoneDataMapper.map(data[1])
      };
      return zoneData;
    }
    return null;
  }
);

export const getZonesMap = (websiteId: number) => createSelector(getZonesHostingState,
  (state: IHostingZoneState) => state.entities[websiteId] && state.entities[websiteId].entities ? state.entities[websiteId].entities : {}
);

export const getAllZonesMap = () => createSelector(getZonesHostingState,
  (state: IHostingZoneState) => state.entities ? state.entities : []
);
export const getAllZonesLoaded = () => createSelector(getZonesHostingState,
  (state: IHostingZoneState) => state.loaded
);

export const getZoneMap = (websiteId: number, zoneId) => createSelector(getZonesHostingState,
    (state: IHostingZoneState) => state.entities[websiteId] ? state.entities[websiteId] : []
);

export const getZone = ( zoneId) => createSelector(getZonesHostingState,
    (state: IHostingZoneState) => {
      if (state.entities && state.entities[zoneId] && !TypeUtils.isEmpty(state.entities[zoneId].entities)) {
        const data = Object.values(state.entities[zoneId].entities);
        const zoneData = {
          records: Object.values(data[0]).map( (record) => HostingDomainsRecordMapper.map(record)),
          zone: HostingDomainsZoneDataMapper.map(data[1])
        };
        return zoneData;
      }
      else {
        return {};
      }
    }
);

export const getZonesLoading = (websiteId: number) => createSelector(getZonesHostingState,
  (state: IHostingZoneState) =>
    state.entities[websiteId].loading
);

export const getZonesLoaded = (websiteId: number) => createSelector(getZonesHostingState,
  (state: IHostingZoneState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);

export const getZoneLoaded = (zoneId: number) => createSelector(getZonesHostingState,
  (state: IHostingZoneState) =>
    state.entities[zoneId] ? state.entities[zoneId].loaded : false
);
